import { useEffect } from 'react';

import { BackActionLabel, BackActionLocation } from './types';
import { useVideoConsultationGlobalState } from './shared/useVideoConsultationGlobalState';

type VideoConsultationBackActionProps = {
   readonly appointmentId: number;
   readonly label: BackActionLabel;
   readonly location: BackActionLocation<unknown>;
   readonly toOriginLabel: BackActionLabel;
};

export const VideoConsultationBackAction = (props: VideoConsultationBackActionProps): null => {
   const { state, setBackAction } = useVideoConsultationGlobalState();
   useEffect(() => {
      if (state.type === 'inCall') {
         setBackAction({
            originId: props.appointmentId,
            backAction: {
               label: props.label,
               toOriginLabel: props.toOriginLabel,
               location: props.location,
            },
         });
      }
   }, [props.appointmentId, props.label, props.location, props.toOriginLabel, setBackAction, state.type]);

   return null;
};
